import { memo } from 'react';
import CategoryMenuBar from '@wconcept/wconcept-ui-renewal/components/organisms/_menuBar/CategoryMenuBar';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import Tag from '@wconcept/wconcept-ui-renewal/components/atoms/Tag';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
  pointColor?: string;
  emphasisTextColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface BrandCollectionItem {
  brandImgSrc?: string;
  brandNameKr?: string;
  brandNameEn?: string;
  value: string;
  isNew?: boolean;
}

interface IProps {
  colorType?: ColorType;
  selectedCateTabId?: string;
  categoryTabType?: 'type1' | 'type7';
  categoryTabList?: React.ReactNode[];
  imgSrc?: string;
  rs?: string;
  priority?: boolean;
  brandItemList?: BrandCollectionItem[];
  isDesktop?: boolean;
  onClick?: (value: string, index: number) => void;
}

const BrandCollectionSection = ({
  colorType = 'white',
  selectedCateTabId,
  categoryTabType = 'type7',
  categoryTabList,
  imgSrc,
  rs,
  priority,
  brandItemList,
  isDesktop,
  onClick,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'brand-collection',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  return (
    <S.BrandCollectionSection
      className={cName}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
      $pointColor={customColors?.pointColor}
      $emphasisTextColor={customColors?.emphasisTextColor}
    >
      {Array.isArray(categoryTabList) && categoryTabList.length > 0 && (
        <CategoryMenuBar
          type={isDesktop ? 'type3' : 'type1'}
          fold={isDesktop}
          isDesktop={isDesktop}
          bgType={isCustomColor || colorType !== 'white' ? 'black' : 'white'}
          items={categoryTabList}
          selectedValue={selectedCateTabId}
          className="category-tab"
        />
      )}
      <Box className="items-grid">
        {brandItemList?.map((item, index) => (
          <Button
            className="brand-item"
            key={item.value}
            onClick={() => onClick?.(item.value, index)}
          >
            <Img
              src={getResizeImageUrl(item.brandImgSrc, rs)}
              priority={priority}
              alt={`${item.brandNameKr} thumbnail`}
            />
            <div className="text-wrap">
              <Text className="brand-name-kr">{item.brandNameKr}</Text>
              <Text className="brand-name-en">{item.brandNameEn}</Text>
            </div>
            {item.isNew && <Tag>NEW</Tag>}
          </Button>
        ))}
      </Box>
    </S.BrandCollectionSection>
  );
};

export default memo(BrandCollectionSection);
